import { Marked } from "marked";
import { cn } from "@/lib/utils";

const marked = new Marked();
// Markdown is markdown — escape any raw HTML the author types.
marked.use({
  renderer: {
    html: () => "",
  },
});

export function Markdown({ source, className }: { source: string; className?: string }) {
  const html = marked.parse(source ?? "") as string;
  return (
    <div
      className={cn("prose max-w-none", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
